<div>
     <app-header></app-header>
</div>
<div class="container-fluid px-3 mt-3">
    <div class="top-heading-sub-heading">
        <h3 class="pt-3">Blogs</h3>
    </div>
</div>
<div class="container-fluid mt-3 mt-sm-4 mt-md-4 px-3">
    <div class="align-items-stretch row">
          <div class="col-md-4 mb-4" *ngFor="let blog of blogArray">
            <div class="normalbox">
              <div class="normalboximg">
                <img 
                  [src]="blog.photo || 'https://raftaar-dev.s3.ap-south-1.amazonaws.com/1732186043132-638581051-popularCategory4.png'" 
                  class="img-fluid normalimg" 
                  alt="{{ blog.title }}" 
                  style="border-radius: 8px;"
                >
              </div>
              <div class="normalboxDetail">
                <!-- <div class="catServices">Published Date: {{ formatDate(blog.created_at)  || 'N/A' }} 
                </div> -->
                <p class="location d-flex align-items-center custom-blog-title">{{ blog.title || 'No Title Available' }}</p>
                <!-- <div>{{ blog.short_description || 'No description available.' }}</div> -->
                <!-- <div [innerHTML]="blog.short_description" class="sort-description"></div> -->
                <div class="ContactSeller mt-2">
                  <a (click)="navigateToBlogDetail(blog?.alias)" style="cursor: pointer;">Read More</a>
                </div>
              </div>
            </div>
          </div>
    </div>


</div>
<div>
    <app-footer></app-footer>
</div>

<!-- <div><app-footer></app-footer></div> -->